import script from "./ButtonMinus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonMinus.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonMinus.vue?vue&type=style&index=0&id=272eb335&scoped=true&lang=css"
import "./ButtonMinus.vue?vue&type=style&index=1&id=272eb335&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-272eb335"]])

export default __exports__